import React from 'react';
import DocumentViewer from '../../../../components/DocumentViewer/DocumentViewer';
import { REACT_APP_BASE_URL } from '../../../../config';
import Documentupload from '../../../../components/documentupload/documentupload';
import { useFormikContext } from 'formik';
import { CloseIcon } from '../../../../components/icons';

const UploadPassport = ({
    url,
    index,
    editable
}: {
    url?: string;
    index: number;
    editable?: boolean;
}) => {
    const { values, setFieldValue } = useFormikContext<any>();

    return (
        <div className='w-[120px]'>
            {url ? (
                <>
                    <p className='block mb-2 text-sm font-medium text-gray700 text-left'>
                        Passport
                    </p>
                    <div className=' flex flex-col h-[100px] items-center justify-center border border-appcolorfaintnine p-4 rounded-[12px] lg:w-[100px] preview-container lg:mb-4 lg:rounded-[3px] lg:border-appcolorfaintgreyblue lg:border-dashed lg:px-[.2rem] lg:py-[.2rem] relative'>
                        {editable && (
                            <div
                                className='rounded-full text-red cursor-pointer absolute top-[-15%] z-10 right-[-15%] bg-red-50 hover:bg-red-100'
                                onClick={() =>
                                    setFieldValue(
                                        `signatories[${index}].passportUrl`,
                                        ''
                                    )
                                }
                            >
                                <CloseIcon color='red' size={25} />
                            </div>
                        )}
                        <DocumentViewer
                            fileUrl={`${REACT_APP_BASE_URL}/${
                                url.split('/v1/')[1]
                            }`}
                        />
                    </div>
                </>
            ) : (
                <Documentupload
                    acceptText='PNG or JPG'
                    accept='.jpg, .png'
                    useAuthorization
                    returnURLOnly
                    title={'Upload Passport'}
                    afterUploadUpdate={(
                        itemId: number,
                        documentUrl: string
                    ) => {
                        setFieldValue(
                            `signatories[${index}].passportUrl`,
                            documentUrl
                        );
                    }}
                />
            )}
        </div>
    );
};

export default UploadPassport;
